import { render, staticRenderFns } from "./Conversion2Trends.vue?vue&type=template&id=9baf3912&scoped=true&"
import script from "./Conversion2Trends.vue?vue&type=script&lang=js&"
export * from "./Conversion2Trends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baf3912",
  null
  
)

export default component.exports